import type { IconSvgObject } from './types';

const Backward01Icon: IconSvgObject = [
  ["path", { d: "M16.0459 18.2104V5.78954C16.0459 5.00722 15.1881 4.52787 14.5218 4.93788L4.42988 11.1483C3.79535 11.5388 3.79534 12.4612 4.42988 12.8516L14.5218 19.0621C15.1881 19.4721 16.0459 18.9927 16.0459 18.2104Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.046 4.5L20.046 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Backward01Icon;
